import { GetBy } from '../_app/cuchillo/core/Element';
import _Header from '../_app/cuchillo/layout/Header';
import { Power3, Power4 } from "gsap";
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { isMobile } from '../_app/cuchillo/core/Basics';

export default class Header extends _Header {
  static options = {
    show: {
      duration: .4,
      delay: 0,
      ease: Power4.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static logoCheck = GetBy.class("logo", this.container)[0];
  static logoMain = GetBy.id("HeaderLogo");
  static claim = GetBy.class("__claim")[0];

  static reset() {
    if (this.y < -this.height) {
      this.y = -this.height
    }
  }

  static resize(__force = false) {
    //super.resize();

    this.height = (this.claim.getBoundingClientRect().top + this.claim.offsetHeight) + this.y * -1;
  }
}


